module.exports = __webpack_public_path__ + "static/bookcrossing-afa7adb45246d791c84a9cb739718b08.png";